import React from "react";

const AUTO_RELOAD_SECONDS = 10;

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, countdown: AUTO_RELOAD_SECONDS };
    this.timerId = null;
  }

  static getDerivedStateFromError() {
    return { hasError: true, countdown: AUTO_RELOAD_SECONDS };
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV !== "production") {
      console.error("ErrorBoundary caught:", error, info);
    }
  }

  componentDidUpdate(_prevProps, prevState) {
    if (this.state.hasError && !prevState.hasError) {
      this.startCountdown();
    }
  }

  componentWillUnmount() {
    if (this.timerId) clearInterval(this.timerId);
  }

  startCountdown = () => {
    if (this.timerId) clearInterval(this.timerId);
    this.timerId = setInterval(() => {
      this.setState((s) => {
        if (s.countdown <= 1) {
          clearInterval(this.timerId);
          window.location.reload();
          return { countdown: 0 };
        }
        return { countdown: s.countdown - 1 };
      });
    }, 1000);
  };

  handleReload = () => {
    if (this.timerId) clearInterval(this.timerId);
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="fetch-failed" role="alert">
          <h2>Etwas ist schiefgelaufen</h2>
          <p>Die App lädt in {this.state.countdown} Sekunden automatisch neu.</p>
          <button
            type="button"
            className="open-button"
            onClick={this.handleReload}
          >
            Jetzt neu laden
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
